import { SeasonsQuery } from "~graphql/sdk";

export const remainingEventsForSeason = (
  events: SeasonsQuery["seasons"][number]["events"],
  isAdmin = false
) => {
  const now = new Date();
  const remaining = events.filter(
    (e) => new Date(e.endDate) > now && (isAdmin || e.isActive)
  );

  return remaining;
};
